module.exports = __webpack_public_path__ + "img/position-pending-selected.5b113ab1.svg";